import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import sologo from '../assets/images/sologo.png';
import logoTrilha from '../assets/images/logo_trilha.png';
import Form from './preIncubacaoForm';
import PreIncubacaoIdeacao from '../preIncubacaoIdeacao/preIncubacaoIdeacao';
import PreIncubacaoPrototipo from '../preIncubacaoPrototipo/preIncubacaoPrototipo';
import PreIncubacaoValidacao from '../preIncubacaoValidacao/preIncubacaoValidacao';
import PreIncubacaoPitch from '../preIncubacaoPitch/preIncubacaoPitch';
import imagemFundo from '../assets/images/trilhaConhecimento/fundo.png';
import imagemFundoIdeacao from '../assets/images/trilhaConhecimento/ideacao/fundo.png';
import { setModoTela, initForm, salvar, getLista, getListaUsuario } from './trilhaConhecimentoActions';
import { getLista as getListaIdeacao } from '../preIncubacaoIdeacao/preIncubacaoIdeacaoActions';
import { getLista as getListaPrototipo } from '../preIncubacaoPrototipo/preIncubacaoPrototipoActions';
import { getLista as getListaValidacao } from '../preIncubacaoValidacao/preIncubacaoValidacaoActions';
import { getLista as getListaPitch } from '../preIncubacaoPitch/preIncubacaoPitchActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import { getLista as getListaVideo } from '../video/videoActions';
import TextoInput from '../texto/textoInput';
import consts from '../consts';

class TrilhaConhecimento extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {
		this.props.getLista();
		this.props.getListaUsuario();
		this.props.getListaIdeacao();
		this.props.getListaPrototipo();
		this.props.getListaValidacao();
		this.props.getListaPitch();
		this.props.getListaTexto();
		this.props.getListaVideo();
	}

    componentWillMount() {
    }

    render() {

		let trilhaAberta = this.props.lista.filter(item => 
			(item.id_usuario == this.props.sessao.id || (item.id_empreendedores || []).includes(this.props.sessao.id)) 
			&& !item.data_final)[0];
		if (this.props.sessao.administrador) {
			trilhaAberta = this.props.lista[0];
		}
		
		let fundo = imagemFundo;
		if (this.props.modoTela == 'ideacao') {
			fundo = imagemFundoIdeacao;
		}

        return (
            <Background
				imagem={fundo}
				backgroundPosition={'center'}
				gradientStart='#0F2748'
				gradientEnd='#0F2748'>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'trilha' ? this.inicial(trilhaAberta) : null}
					
					{this.props.modoTela == 'cadastro' ? <Form onSubmit={this.props.salvar} /> : null}

					{this.props.modoTela == 'ideacao' ? <PreIncubacaoIdeacao trilhaConhecimento={trilhaAberta} /> : null}
					{this.props.modoTela == 'prototipo' ? <PreIncubacaoPrototipo trilhaConhecimento={trilhaAberta} /> : null}
					{this.props.modoTela == 'validacao' ? <PreIncubacaoValidacao trilhaConhecimento={trilhaAberta} /> : null}
					{this.props.modoTela == 'pitch' ? <PreIncubacaoPitch trilhaConhecimento={trilhaAberta} /> : null}

                </Content>
            </Background>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<Row alignCenter>
				<Grid cols='12 10 8 6'>
					<ContentCard>
						<ContentCardBody>
							<Row alignCenter 
								style={{ 
									padding: 16
								}}>
								
								<Grid cols='12 10 6 4'>
									<Button
										text='Iniciar Nova Trilha'
										type={'primary'}
										icon={'fa fa-plus'}
										event={() => {
											this.props.setModoTela('cadastro', {});
											this.props.initForm({});
										}} />
								</Grid>
							</Row>
						</ContentCardBody>
					</ContentCard>
				</Grid>

				{lista.length > 0  &&
				<Grid cols='12 12 12 12'>
					<ContentCard>
						<ContentCardBody>
							<Table responsive>
								<THead>
									<Tr>
										<Th>Nome do Projeto</Th>
										<Th alignCenter>Data/Hora</Th>
										<Th alignCenter>Enviada Por</Th>
										<Th></Th>
									</Tr>
								</THead>
								<TBody>
									{lista.map(item => (
										<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
											onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td>{item.nome_projeto}</Td>
											<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
											<Td alignCenter>{item.nome_usuario}</Td>
											<Td alignRight minWidth={150}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-eye'}
													visible={this.state.linhaSelecionada == item.id}
													event={() => {
														this.props.setModoTela('visualizacao', {
															...item
														});
														this.props.initForm({
															...item
														});
													}} />
											</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</ContentCardBody>
					</ContentCard>
				</Grid>}
			</Row>
		);
	}

	inicial(trilhaAberta) {

		return (
			<>
				<Row alignCenter 
					style={{ 
						padding: 16,
						marginTop: 20
					}}>
					<Grid cols='12 10 8 6'>
						<p style={{ textAlign: 'center', color: '#ffffff', margin: 0, padding: 0 }}>{this.props.trilhaConhecimentoTitulo}</p>
						
						<TextoInput chave='trilhaConhecimentoTitulo' />
					</Grid>
				</Row>
				<Row alignCenter>
					{(!trilhaAberta || this.props.sessao.administrador) &&
					<Grid cols='12 10 8 6'>
						<ContentCard
							style={{
								marginTop: 20,
								backgroundColor: '#0F2748',
								color: '#ffffff',
								borderRadius: 20,
								boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
								opacity: '80%'
							}}>
							<ContentCardBody>
								<Row alignCenter 
									style={{ 
										padding: 16
									}}>
									<Grid cols='12 12 12 12'>
										<h4 style={{ textAlign: 'center' }}>{this.props.trilhaConhecimentoTituloNaoIniciada}</h4>

										<TextoInput chave='trilhaConhecimentoTituloNaoIniciada' />
									</Grid>
									<Grid cols='12 12 12 12' style={{ padding: 16 }}>
										<p style={{ textAlign: 'center' }}>{this.props.trilhaConhecimentoDescricaoNaoIniciada}</p>

										<TextoInput chave='trilhaConhecimentoDescricaoNaoIniciada' />
									</Grid>
								</Row>
							</ContentCardBody>
						</ContentCard>
					</Grid>}
					
				</Row>

				{trilhaAberta ? this.trilha(trilhaAberta) : null}

			</>
		);
	}

	trilha(trilhaAberta) {

		const registroIdeacao = this.props.listaIdeacao.filter(item => item.id_pre_incubacao == trilhaAberta.id)[0];
		const registroPrototipo = this.props.listaPrototipo.filter(item => item.id_pre_incubacao == trilhaAberta.id)[0];
		const registroValidacao = this.props.listaValidacao.filter(item => item.id_pre_incubacao == trilhaAberta.id)[0];
		const registroPitch = this.props.listaPitch.filter(item => item.id_pre_incubacao == trilhaAberta.id)[0];

		return (
			<Row alignCenter>
				
				<Grid cols='12 12 10 8'>
					<Row alignCenter style={{ padding: 8, marginTop: 20 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class='btn btn-trilha btn-block btn-flat'>
								Pré-incubação
							</button>
						</Grid>
					</Row>

					{this.props.listaVideo.map(item => (
						<Row key={item.id} alignCenter style={{ padding: 8, marginTop: 20 }}>
							<Grid cols='12 12 8 6'>
								<div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
									<iframe
										width="100%"
										height="100%"
										src={item.link}
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowFullScreen></iframe>
								</div>
							</Grid>
						</Row>
					))}

					<Row alignCenter style={{ padding: 8, marginTop: 20 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class={`btn btn-trilha btn-block btn-flat`}
								onClick={() => this.props.setModoTela('ideacao')}>
								Ideação
								{trilhaAberta.ideacao ?
									<i class='fas fa-check-double' style={{ marginLeft: 8 }}></i>
								: (registroIdeacao ? 
									<i class='fas fa-check' style={{ marginLeft: 8 }}></i>
								: null)}
							</button>
						</Grid>
					</Row>
					<Row alignCenter style={{ padding: 8, marginTop: 20 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class={`btn btn-trilha${trilhaAberta.ideacao ? '' : '-bloqueada'} btn-block btn-flat`}
								onClick={() => {
									if (trilhaAberta.ideacao) {
										this.props.setModoTela('prototipo');
									} else {
										window.alert('Você precisa concluir a etapa de Ideação')
									}
								}}>
								Protótipo e Validação
								{trilhaAberta.prototipo ?
									<i class='fas fa-check-double' style={{ marginLeft: 8 }}></i>
								: (registroPrototipo ? 
									<i class='fas fa-check' style={{ marginLeft: 8 }}></i>
								: null)}
							</button>
						</Grid>
					</Row>
					<Row alignCenter style={{ padding: 8, marginTop: 20 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class={`btn btn-trilha${trilhaAberta.prototipo ? '' : '-bloqueada'} btn-block btn-flat`}
								onClick={() => {
									if (trilhaAberta.prototipo) {
										this.props.setModoTela('validacao')
									} else {
										window.alert('Você precisa concluir a etapa de Protótipo e Validação')
									}
								}}>
								Modelo de Negócio
								{trilhaAberta.validacao ?
									<i class='fas fa-check-double' style={{ marginLeft: 8 }}></i>
								: (registroValidacao ? 
									<i class='fas fa-check' style={{ marginLeft: 8 }}></i>
								: null)}
							</button>
						</Grid>
					</Row>
					<Row alignCenter style={{ padding: 8, marginTop: 20, marginBottom: 80 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class={`btn btn-trilha${trilhaAberta.validacao ? '' : '-bloqueada'} btn-block btn-flat`}
								onClick={() => {
									if (trilhaAberta.validacao) {
										this.props.setModoTela('pitch')
									} else {
										window.alert('Você precisa concluir a etapa de Modelo de Negócio')
									}
								}}>
								Pitch
								{trilhaAberta.pitch ?
									<i class='fas fa-check-double' style={{ marginLeft: 8 }}></i>
								: (registroPitch ? 
									<i class='fas fa-check' style={{ marginLeft: 8 }}></i>
								: null)}
							</button>
						</Grid>
					</Row>
				</Grid>
				
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.trilhaConhecimento.modoTela,
	aguardando: state.trilhaConhecimento.aguardando,
	lista: state.trilhaConhecimento.lista,
	listaIdeacao: state.preIncubacaoIdeacao.lista,
	listaPrototipo: state.preIncubacaoPrototipo.lista,
	listaValidacao: state.preIncubacaoValidacao.lista,
	listaPitch: state.preIncubacaoPitch.lista,
	trilhaConhecimentoTitulo: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoTitulo').map(item => item.valor)[0],
	trilhaConhecimentoTituloNaoIniciada: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoTituloNaoIniciada').map(item => item.valor)[0],
	trilhaConhecimentoDescricaoNaoIniciada: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoDescricaoNaoIniciada').map(item => item.valor)[0],
	listaVideo: state.video.lista.filter(item => item.trilha == 'pre_incubacao')
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, getLista, getListaUsuario,
	getListaIdeacao, getListaPrototipo, getListaValidacao, getListaPitch,
	getListaTexto, getListaVideo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TrilhaConhecimento);
